import React from 'react';

interface RegionData {
  id: number;
  region: string;
  participants: string;
  growth: string;
  lat: number;
  lng: number;
}

const mockRegions: RegionData[] = [
  { id: 1, region: 'North America', participants: '487,000', growth: '+15%', lat: 40.7128, lng: -74.0060 },
  { id: 2, region: 'Europe', participants: '623,000', growth: '+22%', lat: 51.5074, lng: -0.1278 },
  { id: 3, region: 'Africa', participants: '412,000', growth: '+28%', lat: -1.2921, lng: 36.8219 },
  { id: 4, region: 'Asia', participants: '756,000', growth: '+19%', lat: 35.6762, lng: 139.6503 },
  { id: 5, region: 'South America', participants: '98,000', growth: '+31%', lat: -23.5505, lng: -46.6333 },
  { id: 6, region: 'Oceania', participants: '24,000', growth: '+17%', lat: -33.8688, lng: 151.2093 }
];

const ParticipationMap = () => {
  return (
    <div className="bg-card rounded-lg shadow-md overflow-hidden border border-border">
      <div className="p-6 border-b border-border">
        <h2 className="text-2xl font-headline font-bold text-foreground mb-2">
          Global Participation Map
        </h2>
        <p className="text-sm font-body text-muted-foreground">
          Real-time tracking of SIG Day movement across continents
        </p>
      </div>
      <div className="relative h-96 bg-muted">
        <iframe
          width="100%"
          height="100%"
          loading="lazy"
          title="Global SIG Day Participation Map"
          referrerPolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps?q=-6.369028,34.888822&z=2&output=embed"
          className="w-full h-full"
        />
      </div>
      <div className="p-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {mockRegions.map((region) => (
            <div
              key={region.id}
              className="p-4 bg-muted rounded-lg hover:bg-primary/5 transition-colors duration-200"
            >
              <div className="flex items-center justify-between mb-2">
                <h3 className="text-base font-body font-semibold text-foreground">
                  {region.region}
                </h3>
                <span className="text-xs font-body font-semibold text-success bg-success/10 px-2 py-1 rounded-full">
                  {region.growth}
                </span>
              </div>
              <p className="text-2xl font-headline font-bold text-primary">
                {region.participants}
              </p>
              <p className="text-xs font-body text-muted-foreground mt-1">Active participants</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ParticipationMap;